import fr from 'facet-rest';
import ReadOnlyDateMonthYear from 'Components/UI/Overrides/ReadOnlyGoalFormDate';

const ReadOnlyGoalOverride = fr.metaOverride()
  .nameOverride(['flowStatus'], { hidden: true })
  .nameOverride('amount', { readonly: true, roundToDollar: true })
  .nameOverride('amountSaved', { prompt: 'Amount Saved So Far', readonly: true, roundToDollar: true })
  .nameOverride('priority', { prompt: 'Priority', readonly: true })
  .nameOverride('endDate', { prompt: 'Target Goal Date', _component: () => ReadOnlyDateMonthYear });

export default ReadOnlyGoalOverride;
